import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Personale
export const getPersonale = async () => {
  const response = await axios.get(`${API}/personale`, { headers: getAuthHeaders() });
  return response.data;
};

export const createPersonale = async (data) => {
  const response = await axios.post(`${API}/personale`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const updatePersonale = async (id, data) => {
  const response = await axios.put(`${API}/personale/${id}`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const deletePersonale = async (id) => {
  const response = await axios.delete(`${API}/personale/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

// Fornitori
export const getFornitori = async () => {
  const response = await axios.get(`${API}/fornitori`, { headers: getAuthHeaders() });
  return response.data;
};

export const createFornitore = async (data) => {
  const response = await axios.post(`${API}/fornitori`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const updateFornitore = async (id, data) => {
  const response = await axios.put(`${API}/fornitori/${id}`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteFornitore = async (id) => {
  const response = await axios.delete(`${API}/fornitori/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

// Articoli
export const getArticoli = async (fornitoreId = null) => {
  const url = fornitoreId ? `${API}/articoli?fornitore_id=${fornitoreId}` : `${API}/articoli`;
  const response = await axios.get(url, { headers: getAuthHeaders() });
  return response.data;
};

export const createArticolo = async (data) => {
  const response = await axios.post(`${API}/articoli`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const updateArticolo = async (id, data) => {
  const response = await axios.put(`${API}/articoli/${id}`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteArticolo = async (id) => {
  const response = await axios.delete(`${API}/articoli/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

export const getArticoliDoppioni = async () => {
  const response = await axios.get(`${API}/articoli/doppioni`, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteArticoliDoppioni = async (nome, keepId = null) => {
  const url = keepId 
    ? `${API}/articoli/doppioni/${encodeURIComponent(nome)}?keep_id=${keepId}`
    : `${API}/articoli/doppioni/${encodeURIComponent(nome)}`;
  const response = await axios.delete(url, { headers: getAuthHeaders() });
  return response.data;
};

// Spese
export const getSpese = async (categoria = null) => {
  const url = categoria ? `${API}/spese?categoria=${categoria}` : `${API}/spese`;
  const response = await axios.get(url, { headers: getAuthHeaders() });
  return response.data;
};

export const getSpesa = async (id) => {
  const response = await axios.get(`${API}/spese/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

export const getSpeseGiorno = async (data) => {
  const response = await axios.get(`${API}/spese/giorno/${data}`, { headers: getAuthHeaders() });
  return response.data;
};

export const getSpeseGiornoChiusura = async (data) => {
  const response = await axios.get(`${API}/spese/giorno-chiusura/${data}`, { headers: getAuthHeaders() });
  return response.data;
};

export const createSpesa = async (data) => {
  const response = await axios.post(`${API}/spese`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const updateSpesa = async (id, data) => {
  const response = await axios.put(`${API}/spese/${id}`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const uploadScontrinoSpesa = async (spesaId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(
    `${API}/spese/${spesaId}/upload-scontrino`,
    formData,
    { 
      headers: { 
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      } 
    }
  );
  return response.data;
};

export const deleteSpesa = async (id) => {
  const response = await axios.delete(`${API}/spese/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

// Chiusure
export const getChiusure = async () => {
  const response = await axios.get(`${API}/chiusure`, { headers: getAuthHeaders() });
  return response.data;
};

export const getChiusura = async (id) => {
  const response = await axios.get(`${API}/chiusure/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

export const getFondoCassaPrecedente = async (data) => {
  const response = await axios.get(`${API}/chiusure/fondo-precedente/${data}`, { headers: getAuthHeaders() });
  return response.data;
};

export const createChiusura = async (data) => {
  const response = await axios.post(`${API}/chiusure`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const updateChiusura = async (id, data) => {
  const response = await axios.put(`${API}/chiusure/${id}`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const uploadScontrino = async (chiusuraId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(
    `${API}/chiusure/${chiusuraId}/upload-scontrino`,
    formData,
    { 
      headers: { 
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      } 
    }
  );
  return response.data;
};

export const deleteChiusura = async (id) => {
  const response = await axios.delete(`${API}/chiusure/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

// Ordini
export const getOrdini = async () => {
  const response = await axios.get(`${API}/ordini`, { headers: getAuthHeaders() });
  return response.data;
};

export const createOrdine = async (data) => {
  const response = await axios.post(`${API}/ordini`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const updateOrdineStato = async (id, stato) => {
  const response = await axios.put(`${API}/ordini/${id}/stato?stato=${stato}`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteOrdine = async (id) => {
  const response = await axios.delete(`${API}/ordini/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

// Dashboard
export const getDashboardStats = async () => {
  const response = await axios.get(`${API}/dashboard/stats`, { headers: getAuthHeaders() });
  return response.data;
};

export const getDetailedStats = async (giorni = 30) => {
  const response = await axios.get(`${API}/dashboard/stats/dettagliate?giorni=${giorni}`, { headers: getAuthHeaders() });
  return response.data;
};

export const getDetailedStatsByDate = async (dataInizio, dataFine) => {
  const response = await axios.get(`${API}/dashboard/stats/per-data?data_inizio=${dataInizio}&data_fine=${dataFine}`, { headers: getAuthHeaders() });
  return response.data;
};

// Checklist Cambio Turno - Tasks
export const getChecklistTasks = async () => {
  const response = await axios.get(`${API}/checklist/tasks`, { headers: getAuthHeaders() });
  return response.data;
};

export const createChecklistTask = async (data) => {
  const response = await axios.post(`${API}/checklist/tasks`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const updateChecklistTask = async (id, data) => {
  const response = await axios.put(`${API}/checklist/tasks/${id}`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteChecklistTask = async (id) => {
  const response = await axios.delete(`${API}/checklist/tasks/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

// Checklist Cambio Turno - Compilazioni
export const getChecklistCompilazioni = async () => {
  const response = await axios.get(`${API}/checklist/compilazioni`, { headers: getAuthHeaders() });
  return response.data;
};

export const getChecklistPendenti = async () => {
  const response = await axios.get(`${API}/checklist/compilazioni/pendenti`, { headers: getAuthHeaders() });
  return response.data;
};

export const getChecklistCompilazione = async (id) => {
  const response = await axios.get(`${API}/checklist/compilazioni/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

export const createChecklistCompilazione = async (data) => {
  const response = await axios.post(`${API}/checklist/compilazioni`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const updateChecklistCompilazione = async (id, data) => {
  const response = await axios.put(`${API}/checklist/compilazioni/${id}`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const confermaChecklistCompilazione = async (id, data) => {
  const response = await axios.post(`${API}/checklist/compilazioni/${id}/conferma`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteChecklistCompilazione = async (id) => {
  const response = await axios.delete(`${API}/checklist/compilazioni/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

// ============== CATEGORIE ARTICOLI ==============

export const getCategorieArticoli = async () => {
  const response = await axios.get(`${API}/categorie-articoli`, { headers: getAuthHeaders() });
  return response.data;
};

export const createCategoriaArticolo = async (data) => {
  const response = await axios.post(`${API}/categorie-articoli`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const updateCategoriaArticolo = async (id, data) => {
  const response = await axios.put(`${API}/categorie-articoli/${id}`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteCategoriaArticolo = async (id) => {
  const response = await axios.delete(`${API}/categorie-articoli/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

export const autoClassificaArticoli = async (overwrite = false) => {
  const response = await axios.post(
    `${API}/categorie-articoli/auto-classifica?overwrite=${overwrite}`,
    {},
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// ============== LISTA SPESA ==============

export const getListaSpesa = async (stato) => {
  const params = stato ? `?stato=${stato}` : '';
  const response = await axios.get(`${API}/lista-spesa${params}`, { headers: getAuthHeaders() });
  return response.data;
};

export const addToListaSpesa = async (data) => {
  const response = await axios.post(`${API}/lista-spesa`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const updateListaSpesaItem = async (id, data) => {
  const response = await axios.put(`${API}/lista-spesa/${id}`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const marcaPreso = async (id) => {
  const response = await axios.post(`${API}/lista-spesa/${id}/preso`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const annullaPreso = async (id) => {
  const response = await axios.post(`${API}/lista-spesa/${id}/non-preso`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const archiviaPresi = async () => {
  const response = await axios.post(`${API}/lista-spesa/archivia-presi`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteListaSpesaItem = async (id) => {
  const response = await axios.delete(`${API}/lista-spesa/${id}`, { headers: getAuthHeaders() });
  return response.data;
};

export const svuotaArchivioListaSpesa = async () => {
  const response = await axios.delete(`${API}/lista-spesa/archivio/svuota`, { headers: getAuthHeaders() });
  return response.data;
};

// ============== INVENTARIO ==============

export const updateGiacenza = async (articoloId, data) => {
  // data: { giacenza, note?, tipo? }
  const response = await axios.patch(`${API}/articoli/${articoloId}/giacenza`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const updateSoglia = async (articoloId, data) => {
  // data: { soglia_minima?, quantita_riordino? }
  const response = await axios.put(`${API}/articoli/${articoloId}/soglia`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const getSottoSoglia = async () => {
  const response = await axios.get(`${API}/inventario/sotto-soglia`, { headers: getAuthHeaders() });
  return response.data;
};

export const getSottoSogliaCount = async () => {
  const response = await axios.get(`${API}/inventario/sotto-soglia/count`, { headers: getAuthHeaders() });
  return response.data;
};

export const getMovimentiInventario = async (articoloId = null, limit = 100) => {
  const params = new URLSearchParams();
  if (articoloId) params.append('articolo_id', articoloId);
  params.append('limit', limit);
  const response = await axios.get(`${API}/inventario/movimenti?${params.toString()}`, { headers: getAuthHeaders() });
  return response.data;
};

export const aggiungiSottoSogliaALista = async (articoloIds = null) => {
  const response = await axios.post(
    `${API}/inventario/aggiungi-sotto-soglia-a-lista`,
    { articolo_ids: articoloIds },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const getPrevisioniConsumi = async (giorni = 30) => {
  const response = await axios.get(`${API}/inventario/previsioni?giorni=${giorni}`, { headers: getAuthHeaders() });
  return response.data;
};

// ============== AUDIT LOG (admin only) ==============

export const getAuditLog = async ({ entity_type, action, user_id, limit = 200, skip = 0 } = {}) => {
  const params = new URLSearchParams();
  if (entity_type) params.append('entity_type', entity_type);
  if (action) params.append('action', action);
  if (user_id) params.append('user_id', user_id);
  params.append('limit', limit);
  params.append('skip', skip);
  const response = await axios.get(`${API}/audit-log?${params.toString()}`, { headers: getAuthHeaders() });
  return response.data;
};

export const getEntityHistory = async (entityType, entityId) => {
  const response = await axios.get(`${API}/audit-log/entity/${entityType}/${entityId}`, { headers: getAuthHeaders() });
  return response.data;
};

